import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addWalletConnectSolanaExtension } from '../walletConnect/addWalletConnectSolanaExtension';
export { connectAndVerifyWithWalletConnectSolana } from '../walletConnect/connectAndVerifyWithWalletConnectSolana';
export { connectWithWalletConnectSolana } from '../walletConnect/connectWithWalletConnectSolana';
export type { WalletConnectSolanaWalletProvider } from '../walletConnect/walletConnectSolanaWalletProvider.types';
